
import { useState } from 'react';
import { json } from 'react-router-dom';
import axios from 'axios';
import {useSelector } from "react-redux";
import { toast } from 'react-toastify';

const useCancelOrder = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { user, token } = useSelector((state) => state.auth);

  const cancelOrder = async (orderID,cancelNote ) => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
        
        
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}shipment/cancelOrder/`,
            {
                "order_id":orderID,
                "cancellation_note":cancelNote
            },
        {headers: {
            "Content-Type": "application/json",
            //'Authorization': `Bearer ${token.access}`,
          },}
        
    );
    
        
      if (!response.ok) {
        throw new Error(`Failed to cancel order: ${response.statusText}`);
      }
      
      
      setSuccess(true);
      return true;
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { cancelOrder, isLoading, error, success };
};

export default useCancelOrder;
